module.exports = new __parcel__URL__("partner_4.20401d49.png").toString();